import Toast from "@common/assets/scripts/toast/Toast";

type FlashToast = {
    type: "success" | "info" | "warning" | "error";
    message: string;
    title?: string;
    options?: Record<string, any>;
};

window.addEventListener("crm:flash-toasts", (e: Event) => {
    const detail = (e as CustomEvent).detail as FlashToast[] | undefined;
    if (!detail || !Array.isArray(detail)) return;

    for (const item of detail) {
        const type = item.type ?? "info";
        const title = item.title;
        const options = item.options ?? {};

        const hasTitle = (t: unknown): t is string => typeof t === "string" && t.trim().length > 0;

        if (type === "success") {
            if (hasTitle(title)) Toast.success(item.message, title, options);
            else Toast.success(item.message, undefined, options);
        } else if (type === "error") {
            if (hasTitle(title)) Toast.error(item.message, title, options);
            else Toast.error(item.message, undefined, options);
        } else if (type === "warning") {
            if (hasTitle(title)) Toast.warning(item.message, title, options);
            else Toast.warning(item.message, undefined, options);
        } else {
            if (hasTitle(title)) Toast.info(item.message, title, options);
            else Toast.info(item.message, undefined, options);
        }
    }
});
